'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of gift card
 */ const GiftCard = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 105 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.3984",
                cy: "52.002",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3427_21009)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M29.9302 83.4889L33.1611 81.6236C34.6081 80.7885 35.1035 78.9387 34.2685 77.4917L27.3028 65.4271C26.4678 63.9801 24.6179 63.4846 23.1709 64.3197L19.94 66.185C19.4362 66.4755 19.2649 67.1183 19.5555 67.6222L28.493 83.1029C28.7835 83.6068 29.4263 83.778 29.9302 83.4875V83.4889Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M28.654 64.6445L35.6196 76.7091C35.7473 76.9309 35.8568 77.161 35.9452 77.3968C36.0687 77.7267 36.3789 77.9484 36.7298 77.9835C37.7235 78.0832 38.7101 78.2965 39.6744 78.6263L43.8428 80.0565C46.3635 80.921 49.0526 81.1835 51.6926 80.8214C54.3915 80.4523 56.9628 79.4417 59.1915 77.874L76.0014 66.0509C76.8322 65.4656 77.1171 64.3653 76.6722 63.4502C75.6224 61.2902 72.9361 60.5098 70.8926 61.7702L59.2617 68.9365C56.4926 70.6432 53.3038 71.5456 50.0519 71.5456H44.4084C43.941 71.5456 43.5326 71.1849 43.5186 70.7175C43.5045 70.2333 43.8919 69.8375 44.3719 69.8375H48.5431C52.0322 69.8375 55.4638 68.9477 58.5122 67.2509L60.3452 66.2319C61.2758 65.714 61.6772 64.5786 61.2617 63.5989C60.4182 61.606 58.2049 60.5772 56.1403 61.213L52.4056 62.361C51.5691 62.6179 50.6638 62.507 49.9143 62.0551L47.8301 60.7975C45.5915 59.4474 43.0273 58.7344 40.4126 58.7344C37.6575 58.7344 34.9614 59.526 32.6442 61.0165L28.9389 63.3982C28.5235 63.6649 28.4042 64.2095 28.6512 64.6361C28.6526 64.6389 28.654 64.6417 28.6554 64.6445H28.654Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        x: "37.168",
                        y: "31.3027",
                        width: "33.9649",
                        height: "21.7544",
                        rx: "2.08135",
                        fill: theme.ds5.asset[assetColor]["600"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip1_3427_21009)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M46.7527 31.3027V38.0608C45.8298 36.681 44.4456 35.0234 43.0108 34.8076C42.3042 34.7012 41.6428 34.9426 41.0987 35.5046C40.6804 35.9367 40.0484 36.8231 40.5117 37.909C40.8 38.584 41.4507 39.1566 42.2976 39.6079H37.1719V33.2343C37.1719 32.1677 38.0406 31.3027 39.1115 31.3027H46.7523H46.7527Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M71.1397 33.2343V39.6079H52.3733C53.2196 39.1566 53.8706 38.5843 54.159 37.909C54.6229 36.8231 53.9906 35.9363 53.5723 35.5046C53.0278 34.9423 52.3658 34.7012 51.6598 34.8076C50.225 35.0234 48.8405 36.681 47.918 38.0608V31.3027H69.2C70.2715 31.3027 71.14 32.1677 71.14 33.2343H71.1397Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M71.1368 40.7562V51.1161C71.1368 52.183 70.268 53.0477 69.1968 53.0477H39.1115C38.0403 53.0477 37.1719 52.1827 37.1719 51.1161V40.7559H45.4237C44.082 41.8115 42.2917 43.6374 41.5369 46.2682C41.4488 46.5755 41.6275 46.8955 41.9362 46.9836C41.9893 46.9988 42.043 47.006 42.0961 47.006C42.3492 47.006 42.5819 46.8402 42.6547 46.5861C43.4388 43.8532 45.5581 42.0529 46.7526 41.2224V53.0474H47.9151V41.2224C49.1097 42.0529 51.2289 43.8532 52.013 46.5857C52.0858 46.8402 52.3185 47.006 52.5716 47.006C52.6244 47.006 52.6784 46.9985 52.7318 46.9836C53.0402 46.8959 53.2189 46.5755 53.1311 46.2679C52.376 43.6371 50.5857 41.8112 49.244 40.7559H71.1368V40.7562Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M53.0871 37.4555C52.662 38.4511 50.5789 39.3407 48.3516 39.5575C48.5784 39.1762 48.8726 38.7109 49.2106 38.2402C50.1959 36.8704 51.1265 36.0573 51.8316 35.9513C51.8772 35.9444 51.9281 35.9395 51.9831 35.9395C52.1824 35.9395 52.442 36.0066 52.7335 36.3074C53.2583 36.8496 53.1868 37.2225 53.0871 37.4555Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M46.3175 39.5575C44.0901 39.3407 42.0068 38.4514 41.5819 37.4558C41.4823 37.2225 41.411 36.8496 41.9359 36.3074C42.2273 36.0066 42.4866 35.9395 42.6859 35.9395C42.7415 35.9395 42.7921 35.9444 42.8374 35.9513C43.5403 36.0567 44.4678 36.8654 45.45 38.2287C45.7911 38.7025 46.0882 39.1727 46.3175 39.5575Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip0_3427_21009",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "57.4694",
                            height: "61.1719",
                            fill: "white",
                            transform: "translate(19.4141 22.4609)"
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip1_3427_21009",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "33.9649",
                            height: "21.7544",
                            fill: "white",
                            transform: "translate(37.1719 31.3027)"
                        })
                    })
                ]
            })
        ]
    });
};

exports.GiftCard = GiftCard;
//# sourceMappingURL=GiftCard.cjs.map
